const CONFIG = {
    api: process.env.VUE_APP_BASE_API
};

export default CONFIG;